import { useState, useEffect } from "react";
import {
  VIEWPORT_BREAKPOINTS,
  MOBILE_BREAKPOINT,
  getViewportState,
  applyViewportCssVars,
} from "utils/viewportCss";

export { VIEWPORT_BREAKPOINTS, MOBILE_BREAKPOINT };

export default function useViewport() {
  const read = () => {
    if (typeof window === "undefined") {
      return getViewportState(VIEWPORT_BREAKPOINTS.mobile, 800);
    }
    const w = window.visualViewport?.width ?? window.innerWidth;
    const h = window.visualViewport?.height ?? window.innerHeight;
    return getViewportState(w, h);
  };

  const [viewport, setViewport] = useState(read);

  useEffect(() => {
    const sync = () => {
      const next = read();
      applyViewportCssVars(next.width, next.height);
      setViewport(next);
    };

    sync();
    window.addEventListener("resize", sync);
    window.addEventListener("orientationchange", sync);
    window.visualViewport?.addEventListener("resize", sync);
    window.visualViewport?.addEventListener("scroll", sync);

    return () => {
      window.removeEventListener("resize", sync);
      window.removeEventListener("orientationchange", sync);
      window.visualViewport?.removeEventListener("resize", sync);
      window.visualViewport?.removeEventListener("scroll", sync);
    };
  }, []);

  return viewport;
}
